module.exports = __webpack_public_path__ + "img/topicMedicalServices.36bd10bc.webp";